import React from 'react';
import PropTypes from 'prop-types';
import { Logger } from 'aws-amplify';

import { makeStyles } from '@material-ui/core/styles';

import {
    Alert,
    AlertTitle,
} from '@material-ui/lab';

const logger = new Logger('ExecutionAlert');

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(1),
  },
}));

export default function ExecutionAlert(props) {
  const { execution } = props;
  const classes = useStyles();

  if(!execution) {
    return(null);
  }
  
  let title=null;
  let message=execution.Message;
  if(execution.Tasks.Failed) {
     title=`${execution.Tasks.Failed}/${execution.Tasks.Started} execution tasks exited unexpectedly!`;
     if(execution.Tasks.LastError) {
       message=`Last Error: ${execution.Tasks.LastError}`;
     }
  }
  
  if(message) {
    logger.info(`EXECUTION ALERT: ${message}`);
    return(
      <Alert className={classes.root} severity='warning'>
        <AlertTitle>{title}</AlertTitle>
        {message}
      </Alert>
    );
  } else {
    return(null);
  }
}

ExecutionAlert.propTypes = {
  execution: PropTypes.object.isRequired,
};